module.exports = __webpack_public_path__ + "72f55b93b01066039ea71b258cd321fb.svg";